<template>
  <div class="wrap">
    <el-row class="header">
      <span :span="1" class="go-back el-icon-back" @click="goBack">

      </span>
      <el-col :span="5">
        <span class="name">
          {{firmwareData.firmwareName}}
        </span>
        <span
         class="status"
         :style="{'background':(firmwareData.verifyStatus === 1?'#edfcf1':'#f7f7f7'),'color':(firmwareData.verifyStatus === 1?'#1E8E39':'#888888')}"
         >
         {{firmwareData.verifyStatus === 0? '未验证': '已验证'}}
         </span>
      </el-col>
    </el-row>
    <el-row class="infos">
      <el-col class="infos-wrap" v-for="(item,index) in infos" :key="index" :span="12">
        <el-col :span="4" class="title">{{item.name}}</el-col>
        <el-col :span="10">
          {{item.value}}
          <a v-if="item.code==='firmwareSign'"
          :href="firmwareData.firmwareUrl"
          target="_blank"
          download
          >
          下载</a>
        </el-col>
      </el-col>
    </el-row>
    <el-row class="status">
      <el-col :span="16" class="device-status">
        <!-- <el-col
        :span="4"
        v-for="(item,key,index) in targetDevice"
        :key="index"
        style="padding-right: 24px;"
        :style="[
          {'border-left':(key !== 'total'? '1px solid #eeeff0' : '')},
          {'padding-left':(key === 'total'? '' : '24px') }
        ]"
        >
          <el-col class="num-title">
            <span class="dot" v-if="key!=='total'"
            :style="{background:(key==='success'?'rgb(30, 142, 62)':key==='error'?'rgb(217, 48, 38)': key==='cancle' ? 'rgb(255, 138, 0)' : '')}"
            ></span>
            <span>{{key}}</span>
          </el-col>
          <el-col class="num" :span="4" :key="index">
            {{item}}
          </el-col>
        </el-col> -->
      </el-col>
      <el-col :span="1" :offset="7">
        <el-button icon="el-icon-refresh-right" class="refrash" @click="refrash"></el-button>
      </el-col>
    </el-row>
    <el-tabs v-model="activeName" @tab-click="handleClick" type="card">
      <el-tab-pane
      :label="item.title"
      :name="item.name"
      v-for="item in tabs"
      :key="item.name"
      >
        <!-- <keep-alive> -->
          <component
          v-if="item.name === activeName"
          :is='item.content'
          :firmwareData="firmwareData"
          @getfirmwareName="getfirmwareName"
          :key="timer"
          ></component>
        <!-- </keep-alive> -->
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import BatchMge from '@/components/firmwareUpdate/batchManagement'
import DeviceList from '@/components/firmwareUpdate/deviceList'
import FirmwareFormat from '@/components/firmwareUpdate/firmwareInformation'
export default {
  // props:{
  //   firmwareId
  // },
  data () {
    return {
      timer: '',
      firmwareData: null,
      infos: [
        {
          code: 'firmwareType',
          name: '固件类型'
        }, // firmwareType--0整包，1差包
        {
          code: 'firmwareSign',
          name: '固件签名'
        }, // firewareSign
        {
          code: 'signMethod',
          name: '签名算法'
        }, // signMethod
        {
          code: 'module',
          name: '自定义模块名称'
        } // module
      ],
      /* targetDevice: {
        total: '9',
        success: '2',
        error: '3',
        cancle: '4'
      }, */
      activeName: '0',
      tabs: [
        {
          title: '批次管理',
          name: '0',
          content: BatchMge
        },
        {
          title: '设备列表',
          name: '1',
          content: DeviceList
        },
        {
          title: '固件信息',
          name: '2',
          content: FirmwareFormat
        }
      ]
    }
  },
  created () {
    this.firmwareData = JSON.parse(this.$route.query.row)
    this.infos.forEach(item => {
      if (item.code === 'firmwareType') {
        item.value = this.firmwareData.firmwareType === 0 ? '整包' : '差包'
      }
      if (item.code === 'firmwareSign') {
        item.value = this.firmwareData.firmwareSign
      }
      if (item.code === 'signMethod') {
        item.value = this.firmwareData.signMethod
      }
      if (item.code === 'module') {
        item.value = this.firmwareData.module
      }
    })
  },
  mounted () {
    this.getActiveName()
  },
  methods: {
    refrash () {
      this.$nextTick(() => {
        this.timer = new Date().getTime()
      })
    },
    goBack () {
      window.history.go(-1)
    },
    /* getStrategyList () { // 获取total总数， TODO:
      console.log(this.firmwareData)
    }, */
    getActiveName () {
      if (sessionStorage.getItem('firmwareTab')) {
        this.activeName = sessionStorage.getItem('firmwareTab')// 存本地用户体验不好，还是采用会话存储
      } else {
        this.activeName = '0'
      }
    },
    handleClick (tab) {
      if (tab.name === '0') {
        this.firmwareTab = '0'
      } else if (tab.name === '1') {
        this.firmwareTab = '1'
      } else if (tab.name === '2') {
        this.firmwareTab = '2'
      }
      sessionStorage.setItem('firmwareTab', this.firmwareTab)
    },
    getfirmwareName (val) {
      this.firmwareData.firmwareName = val
    }
  }
}
</script>

<style lang='less' scoped>
  .wrap{
    padding: 0 24px 24px;
  }
  .header{
    display: flex;
    align-items: center;
    margin-bottom: 14px;
    .go-back{
      cursor: pointer;
    }
    .el-icon-back{
      font-size: 20px;
      font-weight: bold;
      width: 25px;
    }
    .el-col{
      display: flex;
      align-items: center;
    }
    .el-col-5{
      display: flex;
      align-items: center;
    }
    .name{
      margin-left: 20px;
      font-size: 28px;
      font-weight: bold;
    }
    .status{
      font-weight: normal;
      font-size: 12px;
      padding: 2px 8px;
      border-radius: 15px;
      margin-left: 8px;
      display: inline-block;
    }
  }
  .infos{
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    font-size: 13px;
    color: rgb(136, 136, 136);
    margin-bottom: 16px;
    .infos-wrap{
      margin-bottom: 8px;
      a{
        margin-left: 20px;
        cursor: pointer;
        color: rgb(0, 112, 204);
      }
      .title{
        color: #888888;
      }
    }
  }
  .status{
    display: flex;
    justify-items: center;
    align-items: center;
    margin: 16px 0 16px 0;
    .num-title{
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      .dot{
        width: 8px;
        height: 8px;
        display: block;
        border-radius: 50%;
        margin-right: 8px;
      }
    }
    .num{
      margin-top: 4px;
      font-size: 24px;
    }
    .refrash{
      font-size: 20px;
    }
  }
</style>
